import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Button from '@/components/common/Button';
import Popup from '@/components/common/Popup';
import { TEST_ID } from '@/constants/tests';
import { useAlertPopupStore } from '@/store/alertPopup';
import tracker from '@/utils/EventTracker';
import { nl2br } from '@/utils/string';

const AlertPopup = () => {
  const location = useLocation();
  const {
    isOpen,
    headerText,
    bodyText,
    tiaraPageKey,
    confirmButtonText,
    cancelButtonText,
    shouldCloseAfterConfirm = true,
    onConfirm,
    onCancel,
    closeAlertPopup
  } = useAlertPopupStore();

  useEffect(() => {
    return () => closeAlertPopup();
  }, [location]);

  useEffect(() => {
    if (tiaraPageKey) {
      tracker.setPage(tiaraPageKey).setSection(tiaraPageKey).trackPage({ pageKey: tiaraPageKey }).track();
    }
  }, [tiaraPageKey]);

  return (
    <Popup open={isOpen} className="alert_layer" style={{ zIndex: 10000 }}>
      <Popup.Header>{headerText && <Popup.Title>{headerText}</Popup.Title>}</Popup.Header>
      <Popup.Body>
        <p className="txt_layer">{typeof bodyText === 'string' ? nl2br(bodyText) : bodyText}</p>
      </Popup.Body>
      <Popup.Footer>
        <div className="group_btn">
          {cancelButtonText && (
            <Button
              data-testid={TEST_ID.ALERT_CANCEL}
              size="m"
              variant="primary"
              onClick={async () => {
                await onCancel?.();
                closeAlertPopup();
              }}
            >
              <span className="txt_btn">{cancelButtonText}</span>
            </Button>
          )}
          {confirmButtonText && (
            <Button
              data-testid={TEST_ID.ALERT_CONFIRM}
              size="m"
              variant="highlight"
              onClick={async () => {
                await onConfirm?.();
                shouldCloseAfterConfirm && closeAlertPopup();
              }}
            >
              <span className="txt_btn">{confirmButtonText}</span>
            </Button>
          )}
        </div>
      </Popup.Footer>
    </Popup>
  );
};

export default AlertPopup;
